<template>
  <v-container v-if="template"
               fluid>
    <PageTitle>
      {{ template.name }}
    </PageTitle>

    <v-card v-if="canBeDeleted"
            class="mb-4">
      <v-card-title>
        Are you sure you want to delete this email template?
      </v-card-title>
      <v-card-text>
        <p v-if="template.metrics.created_count > 0">
          This will also delete {{ template.metrics.created_count | pluralize('email') }} that used this template.
        </p>
        <p v-else>
          No emails were sent using this template.
        </p>
        <p class="mb-0">
          This cannot be undone.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn @click.prevent="deleteTemplate"
               :disabled="canBeDeleted === false"
               color="error">
          Yes, delete the template
        </v-btn>
        <v-btn @click.prevent="cancel">
          No, do not delete this email template
        </v-btn>
      </v-card-actions>
      <ErrorAlert v-if="error"
                  :error="error">
      </ErrorAlert>
    </v-card>
    <v-alert v-else
             type="error"
             tile>
      You cannot delete this template because it is a quick share template.<br/>
      <router-link :to="{name: 'admin.share_template.edit', params: {templateID: template.id}}" class="white--text">Edit the template</router-link> so it is not a quick share template, then try again.
    </v-alert>
  </v-container>
</template>
<script>
import PageTitle from '../../components/PageTitle.vue';
import shareTemplateService from '../../../../ml/services/shareTemplateService';
import ErrorAlert from '../../components/ErrorAlert.vue';

export default {
  components: {ErrorAlert, PageTitle},
  data() {
    return {
      busy: false,
      error: null,
      template: null,
    }
  },
  computed: {
    templateID() {
      return parseInt(this.$route.params.templateID);
    },
    canBeDeleted() {
      if (!this.template) {
        return false;
      }
      return this.template.is_quick_share === false;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.template = await this.fetchTemplate();
    },
    async fetchTemplate() {
      try {
        return await shareTemplateService.getTemplate(this.templateID);
      } catch (e) {
        await this.$router.replace({name: 'admin.share_templates.index'});
      }
    },
    async deleteTemplate() {
      if (this.busy) {
        return;
      }
      if (this.template.is_quick_share) {
        return;
      }
      this.busy = true;
      try {
        await shareTemplateService.destroy(this.templateID);
        this.$toast.success('Email template deleted.');
        this.$store.dispatch('fetchShareTemplates').then(); // MLD-6865
        return await this.$router.replace({name: 'admin.share_templates.index'});
      } catch (e) {
        this.error = e;
        this.busy = false;
      }
    },
    async cancel() {
      await this.$router.back();
    }
  }
}
</script>
